<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Reconcile Store Stock",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DataTable,
  },
  data() {
    return {
      title: "Store Stock Taking",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Stock Take",
          active: true,
        },
      ],
      totalRows: 1,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsStoreStockPaginated: true,
      serverPerPage: 50,
      filter: null,
      filterOn: [],
      sortDesc: false,
      modal_id: "",
      filterStoreStock: {
        product: "",
        category: "",
        page: 1,
        per_page: 50,
      },
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product.product_name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "qty",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "actual_quantity",
          sortable: true,
          label: "ACTUAL QUANTITY",
        },
        {
          key: "units",
          label: "UNIT RECONCILE",
        },
      ],

      // Value from user input for adding position
      inputs: {
        id: "",
        qty: "",
      },
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("store", [
      "StoreStock",
      "StoreStockPagination",
      "StoreStockPaginated",
      "SaveStatus",
    ]),
    rows() {
      return this.IsStoreStockPaginated
        ? this.StoreStockPagination?.total
        : this.StoreStock
        ? this.StoreStock.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsStoreStockPaginated) {
          return (
            (this.StoreStockPagination && this.StoreStockPagination.per_page) ||
            this.filterStoreStock.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsStoreStockPaginated) {
          this.filterStoreStock.per_page = value;
          this.filterStoreStock.page = 1;
          this.FetchToReconcile(this.filterStoreStock);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.StoreStockPaginated && this.StoreStockPagination
          ? this.StoreStockPagination.current_page
          : 1;
      },
      set(value) {
        if (this.StoreStockPaginated) {
          this.filterStoreStock.page = value;
          this.handlePageChange(value);
        }
      },
    },
    ...mapGetters("auth", ["MyUserPerm"]),
  },

  watch: {
    show(newValue) {
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  methods: {
    ...mapActions({
      FetchToReconcile: "store/fetchStoreStock",
      ReconcileStock: "store/addQty",
      SaveReconcile: "store/SaveReconcile",
    }),

    handleServerSearch() {
      this.filterStoreStock.page = 1;
      this.FetchToReconcile(this.filterStoreStock);
    },

    handlePageChange(newPage) {
      this.filterStoreStock.page = newPage;
      this.FetchToReconcile(this.filterStoreStock);
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    async saveReconcile(data, event, unit_id) {
      data.added_qty = event;
      data.type = 1;
      data.unit_id = unit_id;
      if (data.added_qty != "") {
        await this.ReconcileStock(data);
        // Refresh data after reconcile
        await this.FetchToReconcile(this.filterStoreStock);
      }
    },
    StockReconcile() {
      this.SaveReconcile();
      // Refresh data after saving reconcile
      this.FetchToReconcile(this.filterStoreStock);
    },
  },

  created() {
    this.FetchToReconcile(this.filterStoreStock);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <div class="row">
              <div class="col-12">
                <div>

                </div>
              </div>
            </div> -->
            <div class="row mt-4">
              <!-- Search -->
              <div class="col-12">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filterStoreStock.product"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                      @keyup.enter="handleServerSearch()"
                    ></b-form-input>
                    <button
                      class="btn btn-primary ms-2"
                      type="button"
                      @click="handleServerSearch()"
                    >
                      <b-spinner
                        v-if="SaveStatus"
                        variant="light"
                        small
                        label="Searching"
                      ></b-spinner>
                      <span>Search</span>
                    </button>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="fields"
                  :rows="StoreStock || []"
                  :total-rows="rows"
                  :pagination="StoreStockPagination"
                  :server-pagination="IsStoreStockPaginated"
                  :loading="SaveStatus"
              >
                
                <template #cell(index)="{index}">
                    {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(product.product_name)="{row}">
                  {{ row?.product?.product_name }}
                </template>
                <template #cell(qty)="{row}">
                  {{ row.qty }} {{ row.baseunit }}
                </template>
                <template #cell(actual_quantity)="{row}">
                  {{ row.actual_quantity }}
                  {{ row.actual_quantity ? row.baseunit : "" }}
                </template>
                <template #cell(units)="{row}">
                  <tr v-for="(itemunit, u) in row.units" :key="u">
                    <td>{{ itemunit.unitsym }}</td>
                    <td>
                      <input
                        type="number"
                        class="custom"
                        @blur="
                          saveReconcile(
                            row,
                            $event.target.value,
                            itemunit.id,
                          )
                        "
                        placeholder="Enter Actual Value"
                      />
                    </td>
                  </tr>
                </template>
              </DataTable>
            </div>
          <div class="row">
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
            <div class="row">
              <div
                v-if="MyUserPerm && MyUserPerm.savereconcile_store_stock == 1"
                class="col-12 mr-3"
              >
                <button
                  @click="StockReconcile()"
                  class="btn btn-primary float-end bt"
                >
                  <i class="fa fa-check"></i> Save Changes
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.custom {
  width: 150px;
  height: 30px;
  margin-right: 2px;
  box-sizing: border-box;
  padding: 12px 5px;
}
.bt {
  margin-right: 120px;
  margin-top: 40px;
}
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
